import { render, staticRenderFns } from "./provider-add.vue?vue&type=template&id=84d8ce20&scoped=true&"
import script from "./provider-add.ts?vue&type=script&lang=ts&"
export * from "./provider-add.ts?vue&type=script&lang=ts&"
import style0 from "./provider-add.scss?vue&type=style&index=0&id=84d8ce20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d8ce20",
  null
  
)

export default component.exports